import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import FormikProvider from '../../../shared/forms/formikProvider.component';
import Modal from '../../../shared/modals/modal.component';
import Form from '../../../shared/forms/form.component';

import schema from './connectionForm.schema';

import { Connection, SaveEntityFunction, ConnectionFormData } from '../types';
import { OptionsPropType } from '../../../shared/propTypes/common';
import { ConnectionPropTypes, ConnectionsPropTypes } from '../propTypes';
import { SelectOption } from '../../../shared/types';

const ModalTitles = {
  ADD: 'Add Connection',
  EDIT: 'Edit Connection',
};

type AddConnectionModalProps = {
  connections: Connection[],
  entityToEdit: Connection | null,
  hideModal: () => void,
  saveEntity: SaveEntityFunction<ConnectionFormData>,

  isSavingInProgress: boolean,

  openForEdit: boolean,
  isVisible: boolean,

  lookUpData: {
    connectionTypeOptions: SelectOption[],
    enabledFlagOptions: SelectOption[],
    generateJeFlagOptions: SelectOption[],
    bsmJeFlagOptions: SelectOption[],
    deleteRawTbDataOptions: SelectOption[],
    inlineReportGenerationOptions: SelectOption[],
  },
  isBusy: boolean,
}

class AddConnectionModal extends PureComponent<AddConnectionModalProps> {
  static propTypes = {
    connections: ConnectionsPropTypes,
    entityToEdit: ConnectionPropTypes,
    hideModal: PropTypes.func.isRequired,
    saveEntity: PropTypes.func.isRequired,

    isSavingInProgress: PropTypes.bool.isRequired,

    openForEdit: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool.isRequired,

    lookUpData: {
      connectionTypeOptions: OptionsPropType,
      enabledFlagOptions: OptionsPropType,
      generateJeFlagOptions: OptionsPropType,
      bsmJeFlagOptions: OptionsPropType,
      deleteRawTbDataOptions: OptionsPropType,
      inlineReportGenerationOptions: OptionsPropType,
    },
    isBusy: PropTypes.bool.isRequired,
  };

  state = {
    addAnother: false,
  };

  save = (formData: ConnectionFormData, { setSubmitting, resetForm }: any) => {
    const { saveEntity, openForEdit } = this.props;
    const { addAnother } = this.state;

    this.setState({ addAnother: false }, () => {
      saveEntity(formData, openForEdit, {
        callback: resetForm,
        keepOpenAfterSaving: addAnother,
      });
      setSubmitting(false);
    });
  };

  renderModal = ({ formik, schema }: any) => {
    const {
      openForEdit,
      lookUpData,
      hideModal,
      isVisible,
      isSavingInProgress,
      isBusy,
    } = this.props;

    const submit = () => {
      this.setState({
        addAnother: false,
      }, () => formik.handleSubmit());
    };

    const submitAndAddAnotherAction = () => {
      this.setState({
        addAnother: true,
      }, () => formik.handleSubmit());
    };

    const reset = () => {
      hideModal();
      formik.resetForm();
    };

    return (
      <Modal
        className="add-connection-modal"
        title={openForEdit ? ModalTitles.EDIT : ModalTitles.ADD}
        closeAction={reset} // eslint-disable-line react/jsx-no-bind
        dismissText="Cancel"
        dismissAction={reset} // eslint-disable-line react/jsx-no-bind
        submitText="Save"
        submitAction={submit} // eslint-disable-line react/jsx-no-bind
        isSubmitting={formik.isSubmitting || isSavingInProgress}
        submitAndAddAnotherAction={!openForEdit ? submitAndAddAnotherAction : null}
        submitAndAddAnotherText="Save and Add Another"
        isVisible={isVisible}
        isBusy={isBusy}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
          formContext={lookUpData}
        />
      </Modal>
    );
  };

  render() {
    const { entityToEdit, connections, openForEdit } = this.props;

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={entityToEdit}
        onSubmit={this.save as any}
        render={this.renderModal}
        validationContext={{
          entities: connections,
          openForEdit,
        }}
      />
    );
  }
}


export default AddConnectionModal;
